import { useAskInfluencerCommercial } from "@entities/brief/lib/hooks/useAskInfluencerCommercial";
import { IBriefInfluencerV2 } from "@shared/lib/types/briefInfluencerV2";
import { Alert, Flex, Radio } from "antd";
import { useEffect, useState } from "react";

import { IBriefCampaignBriefInfluencer } from "@shared/lib/types/briefCampains";
import { Button } from "@shared/ui/Button";
import { CommercialsTile } from "./CommercialsTile";
import styles from "./styles.module.scss";

interface Props {
  briefInfluencer: IBriefInfluencerV2 | IBriefCampaignBriefInfluencer;
  onClose: () => void;
}

export function AskInfluencerCommercials({ briefInfluencer, onClose }: Props) {
  const [type, setType] = useState<"ask" | "give">("ask");
  const [targetInfluencerCost, setTargetInfluencerCost] = useState<
    number | undefined
  >(undefined);

  const { askInfluencerCommercial, isAsking, isAsked } =
    useAskInfluencerCommercial([briefInfluencer as IBriefInfluencerV2]);

  useEffect(() => {
    if (isAsked) {
      onClose();
    }
  }, [isAsked]);

  const isPricingPocAssigned = Boolean(
    briefInfluencer?.assignedPricingPocV2?.assignedToUserId
  );

  return (
    <Flex vertical gap={24}>
      {!isPricingPocAssigned ? (
        <Alert
          message="Pricing POC not assigned. Please assign a Pricing POC to continue."
          type="warning"
          showIcon
        />
      ) : null}
      <Flex vertical gap={12}>
        <div className={styles.label}>Choose: </div>
        <Radio.Group
          value={type}
          options={[
            { label: "Ask Commercial", value: "ask" },
            { label: "Give Target Commercial", value: "give" },
          ]}
          onChange={(e) => {
            setType(e.target.value);
            setTargetInfluencerCost(undefined);
          }}
        />
      </Flex>
      <Alert
        message={
          type === "ask"
            ? "Influencer will be sent a form where they would be asked the 1st Quote."
            : "Influencer will be sent a form where they would be asked to accept the Target Commercial."
        }
        type="info"
      />
      <CommercialsTile
        briefInfluencers={[briefInfluencer as IBriefInfluencerV2]}
        type={type}
        costValues={{
          [briefInfluencer._id]: {
            isPrimary: briefInfluencer?.isPrimaryContactAdded,
            value: targetInfluencerCost,
          },
        }}
        onChange={(influencerId, value) => {
          setTargetInfluencerCost(value);
        }}
      />

      <Flex justify="end" gap={8}>
        <Button type="default" onClick={onClose}>
          Cancel
        </Button>
        <Button
          type="primary"
          loading={isAsking}
          disabled={
            (type === "give" && targetInfluencerCost === undefined) ||
            !isPricingPocAssigned
          }
          onClick={() =>
            askInfluencerCommercial({
              briefInfluencerId: briefInfluencer._id,
              targetInfluencerCost: targetInfluencerCost,
            })
          }
        >
          Send
        </Button>
      </Flex>
    </Flex>
  );
}
